module.exports = __webpack_public_path__ + "img/gartek-services-plumbing-help-with-needs.535f3778.png";